<script>
    import { timeSoftMethods } from '@state/helpers'
    import { required, maxLength, helpers, minLength, minValue, alphaNum } from 'vuelidate/lib/validators'
    import DatePicker from 'v-calendar/lib/components/date-picker.umd'
    import ConfirmModal from '@components/ConfirmModal.vue'
    import { euroInventoryMethods } from '@state/helpers'
    
    
    // import EuroCouponsItemForm from '@components/euro_coupons/item/Form'
    import XLSX from 'xlsx'
    
    const minRequired = (value) => value.length > 0 && value.length <= 1300
    const someError = (items) => !items.some((item) => item.error === true)
    const mustBeOption = (value) => ['1'].includes(value)
    
    export default {
      name: 'UploadData',
      components: { DatePicker, ConfirmModal },
      props: {
        fullform: {
          type: Boolean,
          required: false,
          default: false,
        },
        instanceJson: {
          type: Object,
          required: false,
          default: () => ({}),
        },
        oncomplete: {
          type: Function,
          required: false,
          default: () => ({}),
        },
        oncancel: {
          type: Function,
          required: false,
          default: () => ({}),
        },
        type_action:{
          type: String,
          default: 'create'
        },
        filters: {
        type: Object,
        required: false,
        default: () => ({}),
      }
      },
      data() {
        return {
          products: [],
          productFields: [ 
              { key: 'SKU', label: 'SKU' },
              { key: 'EAN', label: 'EAN' },
              { key: 'Descripcion corta', label: 'Descripcion corta' },
              { key: 'Proveedor', label: 'Proveedor' },
              { key: 'Documento Proveedor', label: 'Documento Proveedor' },
              { key: 'sku_supplier', label: 'SKU Proveedor' },
              { key: 'ean_supplier', label: 'EAN Proveedor' },
              { key: 'name_supplier', label: 'Nombre Proveedor' },
            ],
          modalShow: true,
          loading: true,
          submitting: false,
          showConfirmModal: false,
          reading: false,
          responseLoaded: false,
          action: 'create',
          selectedFile: false,
          file: null,
          loadingReport: false,
          previewProducts: [],
          form: {
            rows: [
            ],
            date_start:null,
            date_end:null
          },
          quantity: null,
          value: null,
    
      
          items: [],
          modelConfig: {
          },
        }
      },
      validations: {
        form: {
        },
        items: {
          minRequired,
          someError,
          $each: {
          }
        },
      },
      computed: {},
      watch: {
  items: {
    deep: true,
    handler(values) {
      values = values.map((item, index) => {
        return item;
      });

      this.form.rows = values;
      this.quantity = values.length;
      this.value = values.reduce((a, b) => a + b['value'], 0);

      this.updatePreview();
    },
  },
},
    
      mounted: function () {
        let context = this
        context.form = {
          ...context.form,
          ...context.instanceJson,
        }

          context.action = 'create'
          context.loading = false
      },
    
      methods: {
        ...euroInventoryMethods,
        
    
    
        tbodyRowClass(item) {
          return item.error === true ? ['table-danger'] : ''
        },
        removeItem(index) {
          this.items.splice(index, 1)
        },
        toggleError(index) {
          this.items[index].error = !this.items[index].error
        },
    
        confirmReadFile() {
          const context = this;
          context.reading = true;
          setTimeout(() => {
            context.readFile();
            context.resetUploadState();
            context.$bvToast.toast('Archivo procesado', {
              title: 'Éxito',
              appendToast: true,
              variant: 'success',
            });
          }, 500);
        },
        updatePreview() {
    this.previewProducts = this.items.map(item => ({
      ean: item.ean,
      sku: item.sku,
      supplier: item.supplier,
      nit_supplier: item.nit_supplier,
      nit_ean: item.ean_supplier
    }));
  },
        editItem(index) {
          this.items[index].editable = !this.items[index].editable;
        },
        resetUploadState() {
          this.responseLoaded = false;
        },
              readFile() {
            const context = this;
            context.items = [];
            const fileReader = new FileReader();
            const readOpts = {
              cellDates: true,
              type: 'binary',
            };

            const jsonOpts = {
              raw: false,
              cellNF: true,
            };

            fileReader.onload = async (ev) => {
              try {
                context.reading = true;
                const data = ev.target.result;
                const workbook = XLSX.read(data, readOpts);

                const wsname = workbook.SheetNames[0];
                const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], jsonOpts);

                context.items = ws.map(item => ({
                  ...item,

                }));
                const formData = new FormData();
                formData.append('excel_file', context.file);

                await context.$store.dispatch('euroInventory/processExcelData', formData);
                context.responseLoaded = true;

              } catch (e) {
                console.log(e)
                context.reading = false;
                return this.$generate_toast(context, 'error', 'Error al leer archivo');
              }
            };

            fileReader.readAsBinaryString(context.file);
            context.reading = false;
          },
    
    
        importExcel(e) {
          const context = this
          const files = e.target.files
          if (!files.length) {
            return
          } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
            return context.$generate_toast(
              context,
              'error',
              'Seleccionar un archivo con formato xls o xlsx'
            )
          }
          context.file = files[0]
          context.selectedFile = true
          // this.readFile(files[0])
        },
    
        submit() {
          let context = this
          context.submitting = true
          const promise = context.manualCreateProductsHomologated(context.form)
          return promise
            .then((response) => {
              let data = response.data
              if (response.status !== 206) {
                context.$generate_toast(
                  context,
                  'success',
                  `${context.$t('request_template')} ${
                    context.$t('created')
                  } ${context.$t('correctly')}. Los datos han sido procesados correctamente por el sistema.`, 'Éxito', 5000
                )
                setTimeout(() => {
                  context.oncomplete(data.url || null)
                  context.submitting = false
                  context.showConfirmModal = false
                }, 10000)
              } else {
                context.$generate_toast(
                  context,
                  'info',
                  `Algunos datos no fueron registrados.`
                )
                context.submitting = false
                context.showConfirmModal = false
              }
            })
            .catch((error) => {
              context.submitting = false
              context.showConfirmModal = false
              context.$axios_error_noty(error, context)
            })
        },
    
        errorMessage(errors=[]) {
          let context = this
          let listFields = errors.map( (error) => context.$t(error)).join(', ')
          let create_message = 'El beneficiario actualmente posee bonos asociados en los rangos de tiempo especificados.'
          let delete_message = 'No se encontró tarjetahabiente con la información especificada.'
    
          if (errors[0] === 'overlapping_coupons' && context.type_action == 'create'){
            return create_message
          } else if( context.type_action == 'delete') {
            delete_message
          }
          return `Los siguientes campos poseen datos inválidos: ${listFields}. `
        },
    
        confirmSubmit() {
          let context = this
          context.$v.form.$touch()
          context.$v.items.$touch()
          if (context.$v.form.$invalid || context.$v.items.$invalid) {
            context.submitting = false
            context.$generate_toast(
              context,
              'error',
              context.$t('fill_the_required_fields')
            )
            return
          }
          context.showConfirmModal = true
        },
        async getReport() {
          try {
            this.loadingReport = true;
            const filtersQuery = Object.entries(this.filters)
            .map(([key, value]) => value !== '' ? `${key}=${value}` : null)
            .filter(Boolean)
            .join('&');
            const finalFiltersQuery = filtersQuery ? `?${filtersQuery}` : '';

            const excelData = await this.fetchProductsExcel(finalFiltersQuery);

            const blob = new Blob([excelData], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Plantilla de productos.xlsx`);
            document.body.appendChild(link);
            link.click();

            this.loadingReport = false;
          } catch (error) {
            this.loadingReport = false;
            console.error(error);
            this.$axios_error_noty("Se presentó un error en la descarga del archivo.");
          }
        }
      },
    }
    </script>
    
    <template>
      <b-modal
        v-model="modalShow"
        scrollable 
        id='upload-data-modal'
        title="Cargar Productos"
        :size="action === 'create' ? 'xl' : 'xl'"
        @hidden="oncancel"
        @ok.prevent="confirmSubmit"
      >
        <div class="p-0">
          <b-row v-if="loading">
            <b-col md="12">
              <div class="text-center">
                <b-spinner
                  label="Spinning"
                  style="color: #195db2; width: 4rem; height: 4rem"
                ></b-spinner>
              </div>
            </b-col>
          </b-row>
          <b-row v-else class="m-3">
            <b-col md="12">
    
              <div class="mb-3">
                <b-form-group
                  class="text-primary font-weight-bold"
                  :label="$t('upload_data_from_file')"
                >
                  <b-form-file
                    class="border-primary"
                    ref="excel_user_file"
                    :placeholder="$t('select_file')"
                    :drop-placeholder="$t('select_file')"
                    :browse-text="$t('search')"
                    @change="importExcel"
                  />
    
                </b-form-group>
                <b-button variant="outline-primary rounded-lg mx-1" @click="getReport">
                  <b-spinner v-if="loadingReport" small label="Spinning"></b-spinner>
                  <i v-else class="fas fa-download"></i>
                  <span class="ml-1">Descargar Plantilla de Productos</span>
                </b-button>
                <b-button
                variant="primary rounded"
                :disabled="!selectedFile || submitting || (reading && !responseLoaded)"
                @click="confirmReadFile"
              >
                <b-spinner v-if="reading && !responseLoaded" label="Spinning" small></b-spinner>
                <span v-else-if="responseLoaded">
                  <i class="fas fa-file-import"></i>
                  <span>Procesado</span>
                </span>
                <span v-else>
                  <i class="fas fa-file-import"></i>
                  <span>Procesar archivo</span>
                </span>
              </b-button>
              </div>
    
    
            </b-col>
                 <div>
  
                  <h5>Vista previa de Productos</h5>
                  <b-table
                    v-if="items.length"
                    hover
                    small
                    :items="items"
                    :fields="productFields"
                    responsive
                    :thead-class="['text-primary', 'border-primary']"
                    :tbody-tr-class="tbodyRowClass"
                  >
                    <!-- Campo editable SKU Proveedor -->

                    <template #cell(sku_supplier)="row">
                      <b-form-input
                      size="sm"
                      type="text"
                      v-model="row.item['SKU Proveedor']"
                    />
                    </template>
                    <!-- Campo editable EAN Proveedor -->
                    <template #cell(ean_supplier)="row">
                      <b-form-input
                      size="sm"
                      type="text"
                      v-model="row.item['EAN Proveedor']"
                    />
                    </template>

                    <!-- Campo editable Nombre producto para el Proveedor -->
                    
                    <template #cell(name_supplier)="row">
                      <b-form-input
                      size="sm"
                      type="text"
                      v-model="row.item['Nombre Proveedor']"
                    />
                    </template>

                  <template #custom-foot>
                    <b-tr>
                      <b-td
                        colspan="3"
                        class="text-primary font-weight-bold text-right"
                        style="border-top: solid 1px"
                        ><span>Total</span></b-td
                      >
                      <b-td
                        class="border-primary text-center"
                        style="border-top: solid 1px"
                        >{{ $formatDollar(quantity) }}</b-td
                      >
                    </b-tr>
                  </template>
                </b-table>
              </div>
          </b-row>
        </div>
    
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button variant="outline-primary" class="rounded-lg" @click="cancel">
            Cancelar
          </b-button>
    
          <b-button
            :variant=" type_action === 'create' ? 'primary' : 'danger'"
            class="rounded-lg"
            :disabled="!$v.items.minRequired"
            :class="{ disabled: submitting }"
            @click="ok"
          >
            <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
            <span v-if="submitting"> {{ type_action === 'create' ? $t('saving') : $t('deleting') }} </span>
            <span v-else>
              <i :class="{'fe-save': type_action === 'create',
              'far fa-trash-alt': type_action === 'delete'}"></i>
              {{ type_action === 'create' ? $t('create') : $t('delete') }}
            </span>
          </b-button>
        </template>
        <ConfirmModal
          v-if="showConfirmModal"
          :close-modal="
            () => {
              showConfirmModal = false
            }
          "
          :on-submit="submit"
          :submitting="submitting"
          :warningMessage="`¿Esta seguro de ${ type_action === 'create' ? $t('create') : $t('delete') } los registros con la información indicada?`"
        />
      </b-modal>
    </template>
    <style lang="scss">
    
    #upload-data-modal .modal-dialog {
        max-width: 95%;
        height: 95vh;
        display: flex;
    }
    </style>